export default function generateApiKey () {
  const length = 32
  const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  let apiKey = ''

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * charset.length)
    apiKey += charset.charAt(randomIndex)
  }

  return apiKey
}
